import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcIdentity = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M13.488 14.733a7.503 7.503 0 0 0 5.17-9.48 5.503 5.503 0 0 1-.158 10.54v5.292a1 1 0 0 1-.293.707l-.854.854a.5.5 0 0 1-.707 0l-2.043-2.043a.5.5 0 0 1 0-.707L15.5 19l-.897-.897a.5.5 0 0 1 0-.707l.897-.896v-.707a5.487 5.487 0 0 1-2.012-1.06Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M17 7.5a5.5 5.5 0 0 1-7.934 4.934l-4.273 4.273a1 1 0 0 1-.707.293H2.5a.5.5 0 0 1-.5-.5V13a.5.5 0 0 1 .5-.5H4V11a.5.5 0 0 1 .5-.5H6l.566-.566A5.5 5.5 0 1 1 17 7.5Zm-4.5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcIdentity");

export { IcIdentity };
//# sourceMappingURL=ic-identity.js.map
